//
// Copyright (c) 2020 Astute Global, Inc.
//
// Module for handling the list of site maps in the site maps admin page
//

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, Messenger, SelectableListModule) {
  "use strict";

  var TableOfContentsListController = SelectableListModule.extend({
    _onBeforeUnselect: function (model) {
      return model.isValid();
    },
    _onUnselect: function () {
      Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
    },
  });

  return TableOfContentsListController;
});
